﻿import { useSearchParams, useNavigate } from 'react-router-dom';

//components
import StartButton from './StartButton';
import useDevice from '../../../CustomHooks/useDevice'
import { URLS } from '../Utils/constants';
import * as constants from '../Utils/constants';


const SelectMethod = () => {

    const {
        isMobileOrTablet
    } = useDevice();

    const navigate = useNavigate();
     const url = isMobileOrTablet ? URLS.openMobileApp : URLS.openDesktopApp

    const [searchParams] = useSearchParams();
    const appId = searchParams.get('appId');

    return (
        <div className="signature-process">
            <div className="signature-process__container">
                <div className="signature-process__container__card">
                    <h2 className="signature-process__container__card__headline">{constants.selectMethod.headline}</h2>
                    <p className="signature-process__container__card__info">{constants.selectMethod.text}</p>
                    <div className="signature-process__container__card__button-container">
                        <StartButton text={"BankId på samma enhet"} onClick={() => navigate(url)} />
                        <StartButton text={"BankID QR-kod"} onClick={() => navigate(URLS.scanQr)} />
                    </div>                
                </div>
            </div>
        </div>

      )
}


export default SelectMethod;

